import { WebsiteCreated } from '../components';
import Frame from '../layout/Frame';
import Panel from '../layout/Panel';

const WebsiteAdded = () => {
  return (
    <Frame>
      <Panel>
        <h1>NEW WEBSITE ADDED SUCCESSFULLY</h1>
        <WebsiteCreated />
      </Panel>
    </Frame>
  );
};

export default WebsiteAdded;
